import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const projectSettingsSoftwareAccessRedirectRoute: InvariantJiraRoute = {
	name: 'project-settings-software-access-redirect',
	path: '/jira/software/projects/:projectKey/settings/people',
	exact: true,
};
